import Devices from './devices';
export default Devices;
